// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__Evjy3","wrapper":"Summary_wrapper__rwRn7","display":"Summary_display__w+qvK"};